
export function goBack(history) {
    if (history.action === 'PUSH') {
        history.goBack();
    } else {
        history.push('/');
    }
}



// WEBPACK FOOTER //
// ./src/helpers/Url.js